import { useCallback, useContext } from 'react'

import usePrivateModeAccess from 'Pods/ThreeDStudio/Hooks/usePrivateModeAccess'
import { STUDIO_EVENT, trackStudioEvent, trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import { openPaidFeatureModal, openSignInModal } from 'Pods/ThreeDStudio/Store/actions/ui'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

// Shared by every Private Mode switch so they upsell the same way; each switch passes
// the setter for its own state. Users without access never flip it: logged-out users get
// the sign-in modal first (they can't subscribe without an account), logged-in ones the
// paid-feature modal. userLoggedIn comes from the studio page context (the same source the
// sign-in modal's render guard uses), not a bare usePageConfig, whose default channel omits
// isCurrentUser on this fast page.
function usePrivateModeChange(setting, setPrivate) {
  const hasPrivateModeAccess = usePrivateModeAccess()
  const { userLoggedIn } = useContext(ThreeDStudioPageContext)

  const handleEntitledChange = useCallback((isPrivate) => {
    trackSettingsInteraction(setting, isPrivate)
    setPrivate(isPrivate)
  }, [setting, setPrivate])

  const handleLockedChange = useCallback(() => {
    trackStudioEvent(STUDIO_EVENT.SETTINGS_INTERACTION, { setting, locked: true })
    if (!userLoggedIn) {
      openSignInModal('signup')
      return
    }
    openPaidFeatureModal()
  }, [setting, userLoggedIn])

  return {
    hasPrivateModeAccess,
    handlePrivateChange: hasPrivateModeAccess ? handleEntitledChange : handleLockedChange,
  }
}

export default usePrivateModeChange
